import React, { FC, useEffect, useState } from 'react';

import FullscreenPreloader from '~/components/atoms/FullscreenPreloader';
import { USER_ID_KEY } from '~/constants';
import projectConfig from '~/projects/config';
import { growthBook } from '~/services/abTests/growthBook';
import localStorage from '~/services/storage/localStorage';
import { useAppSelector } from '~/store/hooks/useAppSelector';

type Props = {
  children: React.ReactNode;
};

const GrowthBookProvider: FC<Props> = ({ children }) => {
  const [isLoading, setIsLoading] = useState(true);
  const { id, created_at } = useAppSelector((state) => state.profile);

  useEffect(() => {
    (async (): Promise<void> => {
      try {
        const userId = id || localStorage.getByKey(USER_ID_KEY);
        if (userId) {
          await growthBook.init({
            //place for setting extra attributes
            id: userId,
            project: projectConfig.project,
            created_at,
          });

          growthBook.startAbTests();
        } else {
        }
      } finally {
        setIsLoading(false);
      }
    })();
  }, [id]);

  return <>{isLoading ? <FullscreenPreloader /> : <>{children}</>}</>;
};

export default GrowthBookProvider;
